import Iconify from "../iconify";
import IconCode from "@/src/lib/iconCode";
import Link from "next/link";

// REMOVE "file-saver" from package.json if ot needed anymore;

const SampleReport = ({ url }) => {
    return (
        <>
            {url && (
                <Link
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group flex w-full items-center justify-between gap-4 rounded-xl border border-slate-200 bg-white px-5 py-4 shadow-sm transition-all duration-200 hover:border-slate-300 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30"
                >
                    <div className="flex items-center gap-3">
                        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-emerald-50 ring-1 ring-emerald-100">
                            <Iconify
                                icon={IconCode?.eye}
                                width={20}
                                className="text-emerald-600"
                            />
                        </span>
                        <div>
                            <p className="text-sm font-semibold text-slate-900">
                                View Sample Report
                            </p>
                            <p className="text-xs text-slate-500">
                                Opens in a new tab
                            </p>
                        </div>
                    </div>
                    <Iconify
                        icon="material-symbols:open-in-new-rounded"
                        width={18}
                        className="shrink-0 text-slate-400 transition-colors group-hover:text-slate-700"
                    />
                </Link>
            )}
        </>
    );
};

export default SampleReport;
